import { HTTP_CP_MortgageCase, HTTP_CP_SmartSearchCase } from '@api-new/caseservice';
import { ENUM_MortgageCaseStatus, ENUM_SmartSearchCaseStatus } from '@api-new/common';
import { CasePreviewCard } from '@platform/property/models/mortgage-preview-item.model';
import { CasePreviewCardType } from '@shared/enums/case-preview-card-type.enum';
import { OpenCaseType } from '@shared/enums/openCaseType.enum';

const setCasePreviewCardType = (
  numberOfBestDeals: number,
  itemCase: HTTP_CP_MortgageCase | HTTP_CP_SmartSearchCase,
): CasePreviewCardType => {
  if (itemCase) return CasePreviewCardType.CASE_OPENED;
  if (numberOfBestDeals) return CasePreviewCardType.HAS_DEAL;
  return CasePreviewCardType.NO_DEAL;
};

const setCasePreviewCardOpenCaseType = (itemCase: Partial<HTTP_CP_MortgageCase & HTTP_CP_SmartSearchCase>): OpenCaseType => {
  if (!itemCase) return null;
  if (itemCase.mortgageCaseStatus === ENUM_MortgageCaseStatus.MORTGAGE_CASE_STATUS_PIPELINE) return OpenCaseType.ACTIVE;
  if (itemCase.smartSearchCaseStatus === ENUM_SmartSearchCaseStatus.SMART_SEARCH_CASE_STATUS_PIPELINE) return OpenCaseType.ACTIVE;
  return OpenCaseType.LEAD;
};

export const buildPortfolioCasePreviewCard = (
  itemCase: HTTP_CP_MortgageCase | HTTP_CP_SmartSearchCase,
  numberOfDeals = 0,
): CasePreviewCard => ({
  type: setCasePreviewCardType(numberOfDeals, itemCase),
  numberOfDeals,
  openCaseType: setCasePreviewCardOpenCaseType(itemCase),
});
